import React, { useEffect, useRef, useState } from 'react';
import SEO from '../../components/common/SEO';

// image imports
import Cement1   from '../../assets/images/Cement 1.png';
import Cement2   from '../../assets/images/Cement 2.png';
import Cement3   from '../../assets/images/Cement 3.png';
import Cement4   from '../../assets/images/Cement 4.png';
import Heath1    from '../../assets/images/Heath 1.png';
import Health2   from '../../assets/images/Health 2.png';
import Health3   from '../../assets/images/Health 3.png';
import Health4   from '../../assets/images/Health 4.png';
import Oil1      from '../../assets/images/Oil 1.png';
import Oil2      from '../../assets/images/Oil 2.png';
import Oil3      from '../../assets/images/Oil 3.png';
import Oil4      from '../../assets/images/Oil 4.png';
import Education1 from '../../assets/images/Education 1.png';
import Education2 from '../../assets/images/Education 2.jpg';
import Education3 from '../../assets/images/Education 3.png';
import Education4 from '../../assets/images/Education 4.png';
import Defence1  from '../../assets/images/Defence 1.png';
import Defence2  from '../../assets/images/Defence 2.png';
import Defence3  from '../../assets/images/Defence 3.png';
import s1  from '../../assets/images/s1.png';
import s2  from '../../assets/images/s2.png';
import s3  from '../../assets/images/s3.png';
import s4  from '../../assets/images/s4.png';
import s5  from '../../assets/images/s5.png';
import s6  from '../../assets/images/s6.png';
import s7  from '../../assets/images/s7.png';
import s8  from '../../assets/images/s8.png';
import s9  from '../../assets/images/s9.png';
import s10 from '../../assets/images/s10.png';

// category data
const categories = [
  {
    id: 'fmcg',
    label: 'FMCG',
    heading: 'Energy Partners for FMCG',
    color: '#facc15',
    projects: [
      { image: Cement1, title: 'Rafhan Maize',              caption: '6 MW' },
      { image: Cement2, title: 'Pakistan Tobacco Company',  caption: '0.6 MW' },
      { image: Cement3, title: 'Fauji Foods',               caption: '1 MW' },
      { image: Cement4, title: 'Beacon Impex Textile Ltd',  caption: '5.4 MW' },
    ],
  },
  {
    id: 'health',
    label: 'Health',
    heading: 'Clean Energy for the Health Sector',
    color: '#34d399',
    projects: [
      { image: Heath1,  title: 'Eastridge Hospital',       caption: '0.5 MW' },
      { image: Health2, title: 'FF Hospital Rawalpindi',   caption: '1 MW' },
      { image: Health3, title: 'FF Hospital Peshawar',     caption: '1 MW' },
      { image: Health4, title: 'FF Hospital Lahore',       caption: '0.5 MW' },
    ],
  },
  {
    id: 'engineering',
    label: 'Engineering',
    heading: 'Powering the Engineering Sector',
    color: '#60a5fa',
    projects: [
      { image: Oil1, title: 'FAP Marine Terminal',    caption: '1.0 MW' },
      { image: Oil2, title: 'KSB Pumps',              caption: '1 MW' },
      { image: Oil3, title: 'FOTCO – Oil Terminal',   caption: '1.0 MW' },
      { image: Oil4, title: 'Frontier Paper Mills',   caption: '1 MW' },
    ],
  },
  {
    id: 'education',
    label: 'Education',
    heading: 'Powering the Knowledge Corridors',
    color: '#a78bfa',
    projects: [
      { image: Education1, title: 'Foundation University Rwp', caption: '' },
      { image: Education2, title: 'FF School Okara',           caption: '' },
      { image: Education3, title: 'FF School Chakwal',         caption: '' },
      { image: Education4, title: 'APS Sargodha',              caption: '' },
    ],
  },
  {
    id: 'defence',
    label: 'Defence',
    heading: 'Strengthening the Defence Lines',
    color: '#fb923c',
    projects: [
      { image: Defence1, title: 'Upper Punjab',   caption: '14.0 MW' },
      { image: Defence2, title: 'KPK',            caption: '12.0 MW' },
      { image: Defence3, title: 'Central Punjab', caption: '22.5 MW' },
    ],
  },
];

// animated counter
function useCountUp(target, duration = 2000, decimals = 0) {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setStarted(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!started) return;
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(parseFloat((eased * target).toFixed(decimals)));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [started, target, duration, decimals]);

  return { count, ref };
}

function StatCard({ label, value, suffix = '', decimals = 0, delay = 0 }) {
  const { count, ref } = useCountUp(value, 2000, decimals);
  const [visible, setVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={cardRef}
      style={{
        background: 'rgba(255,255,255,0.06)',
        borderRadius: '20px',
        padding: '36px 28px',
        textAlign: 'center',
        borderTop: '3px solid #facc15',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(40px)',
        transition: `opacity 0.7s ease ${delay}ms, transform 0.7s cubic-bezier(0.22,1,0.36,1) ${delay}ms`,
      }}
    >
      <div
        ref={ref}
        style={{
          fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 700,
          color: '#facc15', lineHeight: 1, marginBottom: '12px', letterSpacing: '-1px',
        }}
      >
        {decimals > 0 ? count.toFixed(decimals) : Math.round(count)}{suffix}
      </div>
      <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.65)', fontWeight: 500, lineHeight: 1.4 }}>
        {label}
      </p>
    </div>
  );
}

// category slider
function CategorySlider({ category }) {
  const [current, setCurrent] = useState(0);
  const [animDir, setAnimDir] = useState(null);
  const [animating, setAnimating] = useState(false);
  const total = category.projects.length;

  const navigate = (dir) => {
    if (animating) return;
    setAnimDir(dir);
    setAnimating(true);
    setTimeout(() => {
      setCurrent(prev => (prev + dir + total) % total);
      setAnimating(false);
      setAnimDir(null);
    }, 280);
  };

  const project = category.projects[current];

  return (
    <div style={{ width: '100%' }}>
      <div style={{ position: 'relative', borderRadius: '16px', overflow: 'hidden', aspectRatio: '16/9' }}>
        <img
          src={project.image}
          alt={project.title}
          style={{
            width: '100%', height: '100%', objectFit: 'cover',
            opacity: animating ? 0 : 1,
            transform: animating
              ? `translateX(${animDir === 1 ? '-40px' : '40px'})`
              : 'translateX(0)',
            transition: 'opacity 0.28s ease, transform 0.28s ease',
          }}
        />
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to top, rgba(8,20,48,0.85) 0%, rgba(8,20,48,0.1) 60%)',
        }} />

        <div style={{
          position: 'absolute', bottom: 0, left: 0, right: 0,
          padding: '20px 24px',
          opacity: animating ? 0 : 1,
          transition: 'opacity 0.28s ease',
        }}>
          {project.caption && (
            <span style={{
              display: 'inline-block',
              fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em',
              background: category.color, color: '#0a1628',
              padding: '3px 10px', borderRadius: '20px',
              marginBottom: '6px',
            }}>
              {project.caption}
            </span>
          )}
          <p style={{ fontSize: '15px', fontWeight: 600, color: '#fff', margin: 0 }}>
            {project.title}
          </p>
        </div>

        <button
          onClick={() => navigate(-1)}
          style={{
            position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)',
            width: '36px', height: '36px', borderRadius: '50%',
            background: 'rgba(0,0,0,0.45)', border: '1px solid rgba(255,255,255,0.2)',
            color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', transition: 'background 0.2s ease',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.75)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,0,0,0.45)'}
        >
          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
        <button
          onClick={() => navigate(1)}
          style={{
            position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
            width: '36px', height: '36px', borderRadius: '50%',
            background: 'rgba(0,0,0,0.45)', border: '1px solid rgba(255,255,255,0.2)',
            color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', transition: 'background 0.2s ease',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.75)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,0,0,0.45)'}
        >
          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>

        <div style={{ position: 'absolute', top: '12px', right: '12px', display: 'flex', gap: '5px' }}>
          {category.projects.map((_, i) => (
            <button
              key={i}
              onClick={() => { if (!animating) { setAnimDir(i > current ? 1 : -1); setCurrent(i); } }}
              style={{
                width: i === current ? '18px' : '6px',
                height: '6px', borderRadius: '3px',
                background: i === current ? category.color : 'rgba(255,255,255,0.4)',
                border: 'none', padding: 0, cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
            />
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
        <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)' }}>
          {current + 1} / {total}
        </span>
      </div>
    </div>
  );
}

// main portfolio page
function Portfolio() {
  const [sectionVisible, setSectionVisible] = useState(false);
  const sectionRef = useRef(null);

  const [screenWidth, setScreenWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );
  useEffect(() => {
    function onResize() { setScreenWidth(window.innerWidth); }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const isMobile = screenWidth < 768;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setSectionVisible(true); },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <SEO title="Portfolio" description="View Foundation Solar Energy's impressive portfolio of completed EPC solar projects." url="/projects" />

      {/* page header */}
      <section style={{
        background: 'linear-gradient(135deg, #0a1628 0%, #0d2240 50%, #0f2d5a 100%)',
        padding: '80px 24px 72px', textAlign: 'center',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0, opacity: 0.04,
          backgroundImage: 'linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)',
          backgroundSize: '48px 48px',
        }} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#facc15', marginBottom: '16px' }}>
            Our Work
          </p>
          <h1 style={{ fontSize: 'clamp(36px, 6vw, 64px)', fontWeight: 700, color: '#fff', lineHeight: 1.1, marginBottom: '20px' }}>
            Portfolio
          </h1>
          <div style={{ width: '60px', height: '3px', background: 'linear-gradient(to right, #3b82f6, #facc15)', borderRadius: '2px', margin: '0 auto 28px' }} />

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '8px', flexWrap: 'wrap' }}>
            <div style={{ height: '1px', width: '40px', background: 'rgba(255,255,255,0.2)', flexShrink: 0 }} />
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '10px',
              background: 'rgba(250,204,21,0.12)', border: '1px solid rgba(250,204,21,0.35)',
              borderRadius: '40px', padding: '10px 20px',
            }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#facc15', flexShrink: 0 }} />
              <span style={{ fontSize: 'clamp(13px, 3vw, 15px)', fontWeight: 600, color: '#facc15', letterSpacing: '0.04em' }}>
                Serving the Nation Since 2019
              </span>
            </div>
            <div style={{ height: '1px', width: '40px', background: 'rgba(255,255,255,0.2)', flexShrink: 0 }} />
          </div>

          <p style={{ fontSize: '1rem', color: '#93c5fd', maxWidth: '500px', margin: '16px auto 0', lineHeight: 1.75 }}>
            Delivering clean energy infrastructure across Pakistan — from concept to commissioning.
          </p>
        </div>
      </section>

      {/* stats section */}
      <section style={{
        background: 'linear-gradient(135deg, #0d2240 0%, #0f2d5a 50%, #0d2240 100%)',
        padding: isMobile ? '56px 16px' : '80px 24px',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0, opacity: 0.04,
          backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }} />
        <div style={{ maxWidth: '1100px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', marginBottom: '52px' }}>
            <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#facc15', marginBottom: '10px' }}>
              By the Numbers
            </p>
            <h2 style={{ fontSize: 'clamp(22px, 3.5vw, 36px)', fontWeight: 700, color: '#fff', lineHeight: 1.2 }}>
              Our Impact at a Glance
            </h2>
            <div style={{ width: '48px', height: '3px', background: 'linear-gradient(to right, #1d4ed8, #facc15)', borderRadius: '2px', margin: '14px auto 0' }} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px' }}>
            <StatCard label="Satisfied Customers"               value={50}   suffix="+"     delay={0}   />
            <StatCard label="Megawatts Delivered"               value={100}  suffix="+ MW"  delay={100} />
            <StatCard label="Operation & Maintenance Performed" value={25}   suffix=" MW"   delay={200} />
            <StatCard label="Power Purchase Agreements"         value={38.1} suffix=" MW"   decimals={1} delay={300} />
          </div>
        </div>
      </section>

      {/* projects section */}
      <section
        ref={sectionRef}
        style={{
          background: '#0a1628',
          padding: isMobile ? '56px 16px 64px' : '80px 24px 90px',
          opacity: sectionVisible ? 1 : 0,
          transform: sectionVisible ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.9s ease, transform 0.9s ease',
        }}
      >
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#facc15', marginBottom: '10px' }}>
              Across Sectors
            </p>
            <h2 style={{ fontSize: 'clamp(24px, 4vw, 40px)', fontWeight: 700, color: '#fff', lineHeight: 1.2 }}>
              Our Projects
            </h2>
            <div style={{ width: '48px', height: '3px', background: 'linear-gradient(to right, #1d4ed8, #facc15)', borderRadius: '2px', margin: '14px auto 0' }} />
          </div>

          {categories.map((category, catIdx) => (
            <div key={category.id} style={{ marginBottom: catIdx < categories.length - 1 ? '72px' : '0' }}>

              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
                <div style={{ width: '4px', height: '32px', background: category.color, borderRadius: '2px', flexShrink: 0 }} />
                <div>
                  <span style={{
                    fontSize: '10px', fontWeight: 600, letterSpacing: '0.15em',
                    textTransform: 'uppercase', color: category.color, display: 'block', marginBottom: '2px',
                  }}>
                    {category.label}
                  </span>
                  <h3 style={{ fontSize: 'clamp(16px, 2.5vw, 24px)', fontWeight: 700, color: '#fff', margin: 0 }}>
                    {category.heading}
                  </h3>
                </div>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                gap: isMobile ? '12px' : '16px',
              }}>
                <CategorySlider category={category} />

                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gridTemplateRows: '1fr 1fr',
                  gap: '8px',
                }}>
                  {category.projects.map((project, i) => (
                    <div
                      key={i}
                      style={{
                        position: 'relative', borderRadius: '10px', overflow: 'hidden',
                        aspectRatio: '16/9',
                      }}
                    >
                      <img
                        src={project.image}
                        alt={project.title}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                      <div style={{
                        position: 'absolute', inset: 0,
                        background: 'linear-gradient(to top, rgba(8,20,48,0.8) 0%, transparent 60%)',
                      }} />
                      <div style={{ position: 'absolute', bottom: '8px', left: '10px', right: '10px' }}>
                        {project.caption && (
                          <span style={{
                            fontSize: '9px', fontWeight: 700,
                            background: category.color, color: '#0a1628',
                            padding: '2px 6px', borderRadius: '10px',
                            display: 'inline-block', marginBottom: '3px',
                          }}>
                            {project.caption}
                          </span>
                        )}
                        <p style={{ fontSize: '10px', fontWeight: 600, color: '#fff', margin: 0, lineHeight: 1.3 }}>
                          {project.title}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {catIdx < categories.length - 1 && (
                <div style={{ height: '1px', background: 'rgba(255,255,255,0.07)', marginTop: '72px' }} />
              )}
            </div>
          ))}

        </div>
      </section>

      {/* sponsors partners section */}
      <section style={{ background: '#fff', padding: isMobile ? '48px 0' : '60px 0', overflow: 'hidden' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#1e3a8a', marginBottom: '10px' }}>
            Trusted By
          </p>
          <h2 style={{ fontSize: 'clamp(20px, 3vw, 32px)', fontWeight: 700, color: '#0a1628' }}>
            Our Partners
          </h2>
          <div style={{ width: '48px', height: '3px', background: 'linear-gradient(to right, #1d4ed8, #facc15)', borderRadius: '2px', margin: '12px auto 0' }} />
        </div>

        <div
          style={{ position: 'relative', overflow: 'hidden' }}
          onMouseEnter={e => e.currentTarget.querySelector('.scroll-track').style.animationPlayState = 'paused'}
          onMouseLeave={e => e.currentTarget.querySelector('.scroll-track').style.animationPlayState = 'running'}
        >
          <style>{`
            @keyframes scrollLeft {
              0%   { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            .scroll-track {
              display: flex;
              width: max-content;
              animation: scrollLeft 20s linear infinite;
            }
          `}</style>

          <div className="scroll-track">
            {[s1,s2,s3,s4,s5,s6,s7,s8,s9,s10].map((src, i) => (
              <div key={i} style={{
                flexShrink: 0,
                width: isMobile ? '110px' : '160px',
                height: isMobile ? '56px' : '80px',
                margin: isMobile ? '0 20px' : '0 32px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <img
                  src={src}
                  alt={`Partner ${i + 1}`}
                  style={{
                    maxWidth: isMobile ? '90px' : '140px',
                    maxHeight: isMobile ? '48px' : '70px',
                    width: 'auto', height: 'auto',
                    objectFit: 'contain',
                    filter: 'grayscale(30%)',
                    transition: 'filter 0.3s ease, transform 0.3s ease',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.filter = 'grayscale(0%)'; e.currentTarget.style.transform = 'scale(1.08)'; }}
                  onMouseLeave={e => { e.currentTarget.style.filter = 'grayscale(30%)'; e.currentTarget.style.transform = 'scale(1)'; }}
                />
              </div>
            ))}
            {[s1,s2,s3,s4,s5,s6,s7,s8,s9,s10].map((src, i) => (
              <div key={`dup-${i}`} style={{
                flexShrink: 0,
                width: isMobile ? '110px' : '160px',
                height: isMobile ? '56px' : '80px',
                margin: isMobile ? '0 20px' : '0 32px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <img
                  src={src}
                  alt={`Partner ${i + 1}`}
                  style={{
                    maxWidth: isMobile ? '90px' : '140px',
                    maxHeight: isMobile ? '48px' : '70px',
                    width: 'auto', height: 'auto',
                    objectFit: 'contain',
                    filter: 'grayscale(30%)',
                    transition: 'filter 0.3s ease, transform 0.3s ease',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.filter = 'grayscale(0%)'; e.currentTarget.style.transform = 'scale(1.08)'; }}
                  onMouseLeave={e => { e.currentTarget.style.filter = 'grayscale(30%)'; e.currentTarget.style.transform = 'scale(1)'; }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}

export default Portfolio;